import { observer } from 'mobx-react-lite'

import { useTheme } from '@mui/material'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader'
import { H3, Text } from '@mxenabled/mxui'

import { useGlobalCopyStore } from '../../../common'
import { useDebtsUiStore } from '../../hooks/useDebtsUiStore'
import { DebtsChart } from '../DebtsChart'

const DebtDetailsChart = () => {
  const theme = useTheme()
  const { debts: copy } = useGlobalCopyStore()
  const { selectedDebtChartData } = useDebtsUiStore()

  return (
    <>
      <Card
        sx={{
          '& .MuiCardContent-root:last-child': {
            pb: 0,
          },
        }}
      >
        <CardHeader sx={{ pb: 0 }} title={<H3 sx={{ pb: 4 }}>{copy.details_chart_title}</H3>} />
        <CardContent sx={{ p: 0 }}>
          <DebtsChart debts={[selectedDebtChartData]} height={250} />
        </CardContent>
      </Card>
      <Text
        color={theme.palette.text.secondary}
        sx={{ textAlign: 'center', px: 8, py: 12 }}
        variant="body2"
      >
        {copy.details_chart_description}
      </Text>
    </>
  )
}

export default observer(DebtDetailsChart)
